import { requireManager } from '@platform/utils/require-manager'
import { createFileRoute } from '@tanstack/react-router'

export const Route = createFileRoute('/_authenticated/$workspaceId/usage/')({
  beforeLoad: ({ context: { queryClient }, params: { workspaceId } }) =>
    requireManager(queryClient, workspaceId),
})
